export default "__VITE_ASSET__36ec1f36__"